import { render, staticRenderFns } from "./CancelNjangi.vue?vue&type=template&id=2724da88"
import script from "./CancelNjangi.vue?vue&type=script&lang=js"
export * from "./CancelNjangi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports